import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { take } from 'rxjs';

import { SceneService } from '../../../services/scene.service';

/** Game reset confirm dialog component. */
@Component({
	selector: 'gaw-game-reset-dialog',
	templateUrl: './game-reset-dialog.component.html',
	styleUrls: ['./game-reset-dialog.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatDialogModule, MatIconModule],
})
export class GameResetDialogComponent {
	private readonly dialogRef = inject(MatDialogRef);

	private readonly sceneService = inject(SceneService);

	/** Handles game reset. */
	protected resetGame(): void {
		this.sceneService
			.resetGame()
			.pipe(take(1))
			.subscribe(() => this.closeDialog());
	}

	/** Handles dialog close. */
	protected closeDialog(): void {
		this.dialogRef.close();
	}
}
